import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchPageData } from '../services/api';
import PageRenderer from './PageRenderer';

const PageContainer = () => {
  const [pageContent, setPageContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get route parameters
  const params = useParams();
  
  useEffect(() => {
    const loadPageContent = async () => {
      try {
        setLoading(true);
        const data = await fetchPageData({
          category: params.category,
          country: params.country || '',
          state: params.state || '',
          city: params.city || '',
        });
        
        setPageContent(data);
        setError(null);
      } catch (err) {
        setError('Failed to load page content');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadPageContent();
  }, [params.category, params.country, params.state, params.city]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-blue-500 shadow-lg"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return <PageRenderer htmlContent={pageContent} />;
};

export default PageContainer; 